import type { ComponentPropsWithRef, ElementType } from "react";
import { forwardRef } from "react";
import { Clay } from "../Clay";
import type { ClayComponent, ClayProps } from "../Clay/Clay.types";

const _Flex: ClayComponent = forwardRef(
  <Element extends ElementType>(
    props: ClayProps<Element>,
    ref: ComponentPropsWithRef<Element>["ref"],
  ) => <Clay ref={ref} display="flex" {...props} />,
);

const Flex = Object.assign(_Flex, { displayName: "Flex" });

const _FlexCenter: ClayComponent = forwardRef(
  <Element extends ElementType>(
    props: ClayProps<Element>,
    ref: ComponentPropsWithRef<Element>["ref"],
  ) => <Flex ref={ref} alignItems="center" justifyContent="center" {...props} />,
);

const FlexCenter = Object.assign(_FlexCenter, { displayName: "Flex.Center" });

const _FlexColumn: ClayComponent = forwardRef(
  <Element extends ElementType>(
    { as = "div" as any, ...props }: ClayProps<Element>,
    ref: ComponentPropsWithRef<Element>["ref"],
  ) => <Flex ref={ref} as={as} flexDirection="column" {...props} />,
);

const FlexColumn = Object.assign(_FlexColumn, { displayName: "Flex.Column" });

/**
 * @deprecated Use `Flex.Column` instead
 */
export const Stack = FlexColumn;

const FlexNameSpace = Object.assign(Flex, { Center: FlexCenter, Column: FlexColumn });

export { FlexNameSpace as Flex };
